export default __webpack_public_path__ + "static/media/loanOffer_paying.4645c652.svg";